import { CurrentUser } from '../admin/admin.types';
import { Attachment } from '../attachment/attachment.types';
import { Reactions } from '../reactions/reactions.types';
import { Visibility } from '../visibility/visibility.types';

export type Guest = {
  authToken: string;
  createdAt: string;
  email: string;
  id: number;
  name: string;
  photoThumbUrl: string;
  recruiter: boolean;
  updatedAt: string;
};

export type NoteAssignment = {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  photoNormalUrl: string;
  photoThumbUrl: string;
  timezone: string;
};

export const NEW_NOTE_ID = 'NEW_CANDIDATE_NOTE';
export type NoteId = number | typeof NEW_NOTE_ID;

export type Note = {
  admin: CurrentUser;
  adminId: number;
  attachments: NoteAttachment[];
  body: string;
  bodyJson: object;
  candidateId: null;
  createdAt: string;
  guestId: number;
  guest: Guest;
  id: NoteId | null;
  noteAssignments: NoteAssignment[];
  offerId: number;
  pinnedAt: string | null;
  private?: boolean;
  reactions: Reactions;
  replies: Note[];
  replyToId: number | null;
  text: string;
  triggered: boolean;
  updatedAt: string;
  visibility: Visibility;
};

export type NotePayload = {
  body: string;
  adminIds?: number[];
  id?: number | null;
  replyToId?: number | null;
  private?: boolean;
};

type NoteAttachment = Attachment & { noteId: number; kind: string };
